import { render } from "./VsudTextarea.vue?vue&type=template&id=2cef9693&scoped=true"
import script from "./VsudTextarea.vue?vue&type=script&lang=js"
export * from "./VsudTextarea.vue?vue&type=script&lang=js"

import "./VsudTextarea.vue?vue&type=style&index=0&id=2cef9693&scoped=true&lang=css"
import "./VsudTextarea.vue?vue&type=style&index=1&id=2cef9693&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cef9693"]])

export default __exports__